import dayjs from 'dayjs';

export const DATE_PERIOD_FORMAT = 'MMMM YYYY';
export const DATE_FORMAT = 'DD.MM.YYYY';
export const REVERSE_DATE_FORMAT = 'YYYY-MM-DD';
export const DAILY_FORMAT = 'ddd\nDD MMM';
export const FILE_ATTACHMENT_EXTENSIONS = '.jpg, .jpeg, .png, .pdf, .doc, .docx, .ppt, .pptx';
export const FILE_ATTACHMENT_MAX_SIZE_MB = 3;
export const FILE_ATTACHMENT_MAX_COUNT = 5;
export const MAX_NOTIFICATIONS_COUNT = 5;
export const NOTIFICATION_DISMISS_TIME_MS = 3500;
export const MAX_NOTIFICATION_MESSAGE_LENGTH = 350;
export const BYTES_IN_MB = 1000000;
export const MIN_DATE_FOR_BILLED_ON = dayjs(new Date(2023, 0, 1));
export const MAX_DATE_FOR_BILLED_ON = dayjs().add(+1, 'day').startOf('day');
export const ISSUE_COLLECTOR_URL =
  'https://jira.itransition.com/plugins/servlet/issueCollectorBootstrap.js?collectorId=771d263c&includeJquery=true';
export const AVAILABLE_PERIOD_COUNT = 12;
export const END_OF_QUARTER_MONTHS = [3, 6, 9, 12];
